<template>
  <v-container class="pa-4 pa-sm-8" fluid>
    <v-row class="mt-3 mt-sm-0">
      <h2 class="dark--text text-h5 font-weight-bold ms-2 mb-6">
        Discount
      </h2>
    </v-row>
    <v-row align="right" align-end class="mt-n4 mt-md-0">
      <v-col cols="8" sm="8" lg="8"> </v-col>
      <!-- <v-col cols="8" sm="6" lg="4">
        <v-text-field placeholder="Discount" v-model="searchKey" solo dense @keydown.enter="runSearch()">
          <template v-slot:append>
            <v-icon v-if="searchKey.length > 0" large color="dark" class="me-n2"
              @click="clearSearch()">mdi-close</v-icon>
            <v-icon v-if="searchKey.length == 0" color="dark" class="me-n2" @click="runSearch()">mdi-magnify</v-icon>
          </template>
        </v-text-field>
      </v-col> -->
      <v-col cols="1" sm="2" lg="1 " class="">
        <CreateShopDiscount v-if="hasRole(AdminUserPermissions.PROMO_CODE_ADD)" />
      </v-col>
      <v-col cols="12" sm="2" lg="1" class=" mb-n5 text-end text-sm-start  mt-sm-0">
        <AuditTrialLog auditType="SHOP_DISCOUNT_LOG" />
      </v-col>
      <v-layout>
        <!-- <ExportPromoCode class="mt-n3 " :headers="headers" :promoCodeList="promoCodes" /> -->
      </v-layout>
    </v-row>

    <v-data-table :mobile-breakpoint="0" :headers="headers" :items="discounts" class="elevation-1 mt-6" :loading="loading" :footer-props="{ 'items-per-page-options': [25, 50, 100, 500] }">
      <template v-slot:[`item.isActive`]="{ item }">
        <v-icon v-show="item.isActive" color="primary">mdi-checkbox-marked</v-icon>
        <v-icon v-show="!item.isActive" color="grey">mdi-checkbox-blank-outline</v-icon>
      </template>
      <template v-slot:[`item.startDate`]="{ item }">
        {{ new Date(parseInt(item.startDate)) | moment("MMM DD YYYY") }}
      </template>
      <template v-slot:[`item.endDate`]="{ item }">
        {{ new Date(parseInt(item.endDate)) | moment("MMM DD YYYY") }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-row>
          <CreateShopDiscount :discountInfo="item" v-if="hasRole(AdminUserPermissions.PROMO_CODE_EDIT)" />

          <DeleteDiscount v-if="hasRole(AdminUserPermissions.PROMO_CODE_DELETE)" :promoCode="item" />
        </v-row>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import DeleteDiscount from "../components/DeleteDiscount.vue";
import CreateShopDiscount from "../components/CreateShopDiscount.vue";
import AuditTrialLog from "@/audit-trial-log/components/AuditTrialLog.vue";

export default {
  components: {
    CreateShopDiscount,
    DeleteDiscount,
    AuditTrialLog,
  },
  data() {
    return {
      loading: true,
      discounts: [],
      search: "",
      searchKey: "",
      headers: [
        { text: "Title (English)", value: "titleEn" },
        { text: "Title (Arabic)", value: "titleAr" },
        { text: "Start Date", value: "startDate" },
        { text: "End Date", value: "endDate" },
        { text: "Is Active", value: "isActive" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      options: {
        itemsPerPage: 25,
        page: 1,
      },
    };
  },
  mounted() {
    this.$root.$on("updateShopDiscount", () => {
      this.loading = true;
      this.getAllDiscounts();
    });
  },

  methods: {
    getAllDiscounts() {
      this.loading = true;
      this.$apollo
        .watchQuery({
          query: require("../api/getAllDiscounts.graphql"),
          variables: {
            limit: 2500,
            skip: 0,
            searchKey: this.searchKey,
          },
        })
        .refetch({
          searchKey: this.searchKey,
          limit: this.options.itemsPerPage !== -1 ? this.options.itemsPerPage : 200,
          skip: this.options.page * this.options.itemsPerPage - this.options.itemsPerPage,
        })
        .then(data => {
          this.loading = false;
          if (data.data.getAllDiscounts) {
            this.discounts = data.data.getAllDiscounts.discounts;
            this.totalItems = data.data.getAllDiscounts.totalCount;
          }
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },
    runSearch() {
      this.getAllDiscounts();
    },
    clearSearch() {
      this.searchKey = "";
      this.getAllDiscounts();
    },
  },
  created() {
    if (!this.hasRole(this.AdminUserPermissions.PROMO_CODE_VIEW)) {
      this.$router.push({
        name: "Error404",
      });
    }
    this.getAllDiscounts();
  },
};
</script>
